

<div class="no-data-container">
  <img class="product-img" src="/assets/e-commerce/icons/95.webp" />
  <p class="no-data-text">      {{ "No services" | transloco }}</p>
  <button class="btn btn-add" routerLink="/clinic" style="margin-bottom: 10px;">   {{ "booking" | transloco }}</button>
</div>